// 电子地图皮肤class
export const THEME = {
  WHITE: 'whiteBg',
  DARK: 'darkBg',
}
